import React, {useState} from 'react'





const OrderSuccess = () => {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h1>🎉 Köszönjük a rendelést!</h1>
        <p>Hamarosan kap egy visszaigazoló emailt.</p>
      </div>
    );
  };
  
  export default OrderSuccess;
  